import {useVideoPlayer} from '@components/@shared/VideoPlayer/useVideoPlayer';
import {useTranslations} from 'next-intl';
import {useLayoutEffect} from 'react';

export const useModifyCaptionsControls = () => {
    const {_player} = useVideoPlayer();
    const t = useTranslations();

    useLayoutEffect(() => {
        const captionsControlsId = setTimeout(() => {
            const captionsMenu = _player
                .el()
                .querySelector(
                    '.video-js .vjs-control-bar .vjs-subs-caps-button .vjs-menu',
                ) as HTMLDivElement;

            if (!captionsMenu) {
                return;
            }

            const menuContent = captionsMenu.querySelector(
                'ul.vjs-menu-content',
            ) as HTMLUListElement;

            const menuTitle = document.createElement('p');
            menuTitle.innerHTML = t('player.captions-menu-title');
            menuTitle.classList.add('menuTitle');

            menuContent.insertBefore(menuTitle, menuContent.firstChild);

            const captionsMenuItems = captionsMenu.querySelectorAll(
                'ul.vjs-menu-content li.vjs-menu-item .vjs-menu-item-text',
            );

            captionsMenuItems.forEach(button => {
                if (button.innerHTML === 'subtitles off') {
                    button.innerHTML = t('player.captions-menu-item-off');
                }
            });
        }, 1000);

        return () => {
            clearTimeout(captionsControlsId);
        };
    }, []);
};
